import { Checkbox, FormControlLabel, formControlLabelClasses, FormControlLabelProps, styled } from "@mui/material";

interface ITableSettingsCheckboxProps extends Omit<FormControlLabelProps, "control"> {
	indeterminate?: boolean;
}

const TableSettingsCheckbox = styled(({ checked, onChange, indeterminate, ...props }: ITableSettingsCheckboxProps) => (
	<FormControlLabel
		{...props}
		control={<Checkbox checked={checked} indeterminate={indeterminate} onChange={onChange} />}
	/>
))(() => ({
	[`&.${formControlLabelClasses.root}`]: {
		width: "100%",
		height: "100%",
		marginRight: "0px",
		marginLeft: "0px",
		border: "1px solid #ACACAC",
		borderRadius: "5px"
	}
}));

export default TableSettingsCheckbox;
